import React from 'react'
import './style.css'
import { Link } from 'react-router-dom';

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {

    return (
    <div className="page-container" style={{"margin":"27px"}}>
      <Link className="download-btn" to="/self-help">Self Help</Link>
      <Link className="download-btn" to="/help-from-others">Help from Others</Link>
    </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Help/index.js